import React from "react";

export const RightArrowButton = ({ className, shouldCenterArrows }) => (
    <button
        className={`swiper-custom-arrow-button swiper-custom-arrow-right ${shouldCenterArrows ? 'swiper-arrows-centered': ''} ${className}`}
    >
        <i className="far fa-arrow-right"></i>
    </button>
)
export const LeftArrowButton = ({ className, shouldCenterArrows }) => (
    <button
        className={`swiper-custom-arrow-button swiper-custom-arrow-left ${shouldCenterArrows ? 'swiper-arrows-centered': ''} ${className}`}
    >
        <i className="far fa-arrow-left"></i>
    </button>
)